import apiClient from '../authentication/utils/core/axios';

/**
 * TasksAPI — Company Ops task delegation: admins/staff create tasks, tag
 * them with an org role, assign them to one or more people, and track
 * status/comments. Mirrors RoadmapAPI's shape exactly.
 */
const TasksAPI = {
  fetchTasks: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.status) query.append('status', params.status);
    if (params.priority) query.append('priority', params.priority);
    if (params.org_role_id) query.append('org_role_id', params.org_role_id);
    if (params.assignee_id) query.append('assignee_id', params.assignee_id);
    if (params.source_type) query.append('source_type', params.source_type);
    if (params.source_id) query.append('source_id', params.source_id);
    const res = await apiClient.get(`/admin/tasks/?${query.toString()}`, { timeout: 30000 });
    return res.data;
  },

  fetchTask: async (taskId) => {
    const res = await apiClient.get(`/admin/tasks/${taskId}`);
    return res.data;
  },

  createTask: async (taskData) => {
    const res = await apiClient.post('/admin/tasks/', taskData);
    return res.data;
  },

  updateTask: async (taskId, updates) => {
    const res = await apiClient.patch(`/admin/tasks/${taskId}`, updates);
    return res.data;
  },

  updateTaskStatus: async (taskId, taskStatus) => {
    const res = await apiClient.patch(`/admin/tasks/${taskId}/status`, { status: taskStatus });
    return res.data;
  },

  deleteTask: async (taskId) => {
    await apiClient.delete(`/admin/tasks/${taskId}`);
    return taskId;
  },

  fetchComments: async (taskId) => {
    const res = await apiClient.get(`/admin/tasks/${taskId}/comments`);
    return res.data;
  },

  addComment: async (taskId, body) => {
    const res = await apiClient.post(`/admin/tasks/${taskId}/comments`, { body });
    return res.data;
  },
};

export default TasksAPI;
